import React from 'react';
import ConsultationFields from './ConsultationFields';
import LastConsultFields from './LastConsultFields';

const ConsultSimulatorForm = ({ payers, skus, formData, loading, errors, handleChange, handleSubmit }) => {
  return (
    <div className="search">
      <h4 className="title">Calculate CPT code using custom consultation parameters</h4>
      <form onSubmit={handleSubmit}>
        <ConsultationFields payers={payers} skus={skus} formData={formData} errors={errors} handleChange={handleChange} />
        <LastConsultFields formData={formData} handleChange={handleChange} />
        <button type="submit" className="button" disabled={loading}>Calculate CPT code</button>
      </form>
    </div>
  );
};

export default ConsultSimulatorForm;
